import { IResult } from '../models/result-models';
import { IUserModel } from '../models/user-model';
import { API_BASE_URL, apiDelete, apiGet, apiPost, apiPut } from './api-utils';

const baseUrl = API_BASE_URL + '/v1/users/';

export const getUser = async (uid: string): Promise<IResult<IUserModel>> => {
    const url = baseUrl + uid;
    const result = await apiGet<IUserModel>(url);

    return result;
};

export const saveUser = async (
    user: IUserModel
): Promise<IResult<IUserModel>> => {
    const result = user.guid
        ? await apiPut<IUserModel, IUserModel>(baseUrl, user)
        : await apiPost<IUserModel, IUserModel>(baseUrl, user);
    return result;
};

export const deleteUser = async (uid: string): Promise<IResult<boolean>> => {
    const url = baseUrl + uid;
    const result = await apiDelete<boolean>(url);

    return result;
};

export const getUsernameAvailable = async (
    username: string
): Promise<IResult<boolean>> => {
    const url = baseUrl + '/available/?u=' + encodeURIComponent(username);
    const result = await apiGet<boolean>(url);

    return result;
};
